import { observer } from "mobx-react-lite";
import React from "react";
import { useStores } from "@client/store";
import { useTheme } from "@ugc-ui/lego";
import {
  ButtonStyled,
  Line,
  MenuContent,
  ProfileMenuSharedContentStyled,
  TypographyStyled,
  TypographyStyledCaption,
} from "./ProfileMenuSharedContent.styled";

export const ProfileMenuSharedContent = observer(() => {
  const theme = useTheme();

  const {
    client: {
      authStore: { logout: handleLogout },
      initialDialogStore: { openDialog: handleOpenDialog, dialogData },
    },
  } = useStores();

  return (
    <ProfileMenuSharedContentStyled>
      <MenuContent theme={theme}>
        <TypographyStyledCaption theme={theme} type="tablecaption">
          НАЗВАНИЕ ЮРИДИЧЕСКОГО ЛИЦА
        </TypographyStyledCaption>
        <TypographyStyled theme={theme} type="subtitle1">
          {dialogData?.legalEntityName || <span>&mdash;</span>}
        </TypographyStyled>

        <TypographyStyledCaption theme={theme} type="tablecaption">
          САЙТ
        </TypographyStyledCaption>
        <TypographyStyled theme={theme} type="subtitle1">
          {dialogData?.legalEntityNameLink || <span>&mdash;</span>}
        </TypographyStyled>

        <TypographyStyledCaption theme={theme} type="tablecaption">
          ИНН
        </TypographyStyledCaption>
        <TypographyStyled theme={theme} type="subtitle1">
          {dialogData?.itn || <span>&mdash;</span>}
        </TypographyStyled>

        <ButtonStyled
          variant="text"
          startIcon="edit-entity"
          color="default"
          onClick={() => handleOpenDialog(dialogData)}
        >
          Редактировать
        </ButtonStyled>

        <Line theme={theme} />

        <ButtonStyled
          variant="text"
          startIcon="logout"
          color="default"
          onClick={handleLogout}
        >
          Выход
        </ButtonStyled>
      </MenuContent>
    </ProfileMenuSharedContentStyled>
  );
});
